define(function() {
  var IpsModelCollection = require('civicsBase/ipsModelCollection');

  return IpsModelCollection.extend({
    urlRoot: '/delegate/civics-api/api/portal/autocomplete/{0}/{1}/{2}/{3}/{4}?FilterMoniker={5}',
    //urlRoot: '/delegate/civics-api/api/portal/autocomplete/{0}/{1}/{2}/{3}/{4}',
    url: function() {
      //core/filercodes/{portletId}.{conditionModel}/{modelProperty}/{modelPropertyValue}', v1
      //core/filercodes/{portletId}/{conditionModel}/{conditionModelProperty}/{modelPropertyValue}/{elementId}?moniker={monikerValue}', v1
      //let combinationPortletIdModel = `${this.portletId}.${this.conditionModel}`;

      let propertyBindValue = '';
      if (this.conditionModelPropBindValue != undefined && this.conditionModelPropBindValue.length > 0){
        propertyBindValue = this.encodeComponent(this.conditionModelPropBindValue);
      }

      var url = this.urlRoot.format(this.portletId,
        this.conditionModel,
        this.conditionModelPropBind,
        this.targetFieldId,
        propertyBindValue,
        this.filterMoniker);

      return url;
    },
    parse: function(response) {

      let codeDescriptionList = [];

      if (response.documents && response.documents.length > 0) {
				response.documents.forEach(doc => {
					if (doc.entries) codeDescriptionList.push(doc.entries);
				});
			}

      //after check for duplicates.?

      codeDescriptionList.forEach( entry => {
        let strIsDefaultOption = entry['IsDefaultOption'] || 'false';
        entry['IsDefaultOption'] = JSON.parse(strIsDefaultOption.toLowerCase());
        entry['Description'] = entry['Description'] || i18n.t('CIVICS.COMMON.VALUE_NOT_CONFIG');
        //let's convert the boolean string here to avoid further processing on other views.
      });

      //sort it by Description.
      codeDescriptionList.sort((a, b) => (a.Description.localeCompare(b.Description)));


      return codeDescriptionList;
    }
  });
});
